import * as Yup from 'yup';

export const AddInvestorsModal = Yup.object().shape({
    firstName: Yup.string().required('f:validation.required'),
    lastName: Yup.string().required('f:validation.required'),
    email: Yup.string().email('f:validation:emailAddress').required('f:validation.required'),
    companyName: Yup.string().required('f:validation.required'),
});
